import { type ComponentPropsWithoutRef, useMemo } from "react";
import { useBuilderStore } from "../Hooks/useBuilderStore";
import { useCanvasToolsPositionsContext } from "./CanvasToolsPositionsContext";

const useOffsetStyles = () => {
  const { shouldShowCanvasToolsInsideFirstBlock } = useBuilderStore(state => ({
    shouldShowCanvasToolsInsideFirstBlock:
      state.shouldShowCanvasToolsInsideFirstBlock,
  }));
  const { positions, blockActionsRef, blockActionsRect } =
    useCanvasToolsPositionsContext();

  const offsetStyles = useMemo(() => {
    const normalOffsetStyles = {
      transform: "translateY(-100%)",
    };
    if (!blockActionsRect) return normalOffsetStyles;
    if (!shouldShowCanvasToolsInsideFirstBlock) return normalOffsetStyles;

    const selectedBlockTop = positions.elementRect.top;
    // There is no space for the toolbar to be shown outside the block
    if (selectedBlockTop < blockActionsRect.height) {
      return {};
    }

    return normalOffsetStyles;
  }, [positions, shouldShowCanvasToolsInsideFirstBlock, blockActionsRect]);

  return { blockActionsRef, offsetStyles };
};

export interface CanvasToolsBlockActionsProps
  extends ComponentPropsWithoutRef<"div"> {}

export const CanvasToolsBlockActions = ({
  children,
}: CanvasToolsBlockActionsProps) => {
  const { blockActionsRef, offsetStyles } = useOffsetStyles();

  return (
    <div
      className="absolute end-0 top-0"
      ref={blockActionsRef}
      style={offsetStyles}
    >
      <div className="bg-circle pointer-events-auto my-1.5 flex items-center gap-0.5 rounded p-1">
        {children}
      </div>
    </div>
  );
};
